const SkeletonRow = () => (
  <tr className="border-b">
    <td className="py-3 px-4">
      <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
    </td>
    <td className="py-3 px-4">
      <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
    </td>
    <td className="py-3 px-4">
      <div className="h-6 bg-gray-200 rounded-full animate-pulse w-20"></div>
    </td>
    <td className="py-3 px-4">
      <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
    </td>
  </tr>
);

export default SkeletonRow;
